import ScheduleResource from "./schedule.resource";

const scheduleModule = angular
  .module("app.resources.schedule", [])
  .service("Schedule", ScheduleResource);

export default scheduleModule;



// WEBPACK FOOTER //
// ./src/resources/schedule/schedule.module.js